import styled, { keyframes, css } from "styled-components";

const expandIn = keyframes`
  from { opacity: 0; transform: scale(0.8) translateY(20px); }
  to { opacity: 1; transform: scale(1) translateY(0); }
`;

export const ChatWrapper = styled.div`
  position: fixed;
  bottom: 25px;
  right: 25px;
  z-index: 10001;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  /* 🔑 A MÁGICA ESTÁ AQUI: */
  pointer-events: none; /* Permite que cliques passem por dentro do wrapper */
`;

export const ChatContainer = styled.div`
  width: 380px;
  height: 550px;
  background: #000;
  border: 1px solid #d4af37;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.8), 0 0 15px rgba(212, 175, 55, 0.2);
  margin-bottom: 15px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  transform-origin: bottom right;

  /* 🔑 Restaura a interatividade quando o chat está aberto */
  pointer-events: all;

  ${(props) =>
    props.isOpen
      ? css`
          opacity: 1;
          transform: scale(1);
          visibility: visible;
        `
      : css`
          opacity: 0;
          transform: scale(0);
          visibility: hidden;
          pointer-events: none;
        `}
`;

export const ChatHeader = styled.div`
  background: linear-gradient(to right, #000, #1a1a1a);
  padding: 15px;
  border-bottom: 1px solid #d4af37;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .title {
    display: flex;
    align-items: center;
    gap: 10px;
    color: #d4af37;
    font-weight: bold;
    text-transform: uppercase;
    font-size: 13px;

    img {
      height: 30px;
      width: auto;
      object-fit: contain;
    }
  }

  button {
    background: none;
    border: none;
    color: #d4af37;
    font-size: 24px;
    cursor: pointer;
    transition: 0.2s;
    &:hover {
      transform: scale(1.1);
      filter: brightness(1.2);
    }
  }
`;

export const MessageList = styled.div`
  flex: 1;
  padding: 15px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 12px;
  background: radial-gradient(circle at center, #111 0%, #000 100%);

  &::-webkit-scrollbar {
    width: 5px;
  }
  &::-webkit-scrollbar-thumb {
    background: #d4af37;
    border-radius: 10px;
  }
`;

export const MessageBubble = styled.div`
  max-width: 90%;
  padding: 12px 16px;
  border-radius: 12px;
  font-size: 13.5px;
  line-height: 1.5;
  animation: ${expandIn} 0.2s ease-out;
  word-wrap: break-word;

  p {
    margin: 0 0 8px 0;
  }
  p:last-child {
    margin-bottom: 0;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    margin: 10px 0;
    font-size: 11px;
    background: #111;
    display: block;
    overflow-x: auto;
  }

  th,
  td {
    border: 1px solid #333;
    padding: 6px 8px;
    text-align: left;
    min-width: 80px;
  }

  th {
    background-color: #d4af37;
    color: #000;
    font-weight: bold;
  }

  ${(props) =>
    props.isUser
      ? css`
          align-self: flex-end;
          background: #d4af37;
          color: #000;
          border-bottom-right-radius: 2px;
          th {
            background: #000;
            color: #d4af37;
          }
        `
      : css`
          align-self: flex-start;
          background: #222;
          color: #fff;
          border-bottom-left-radius: 2px;
          border: 1px solid #333;
        `}

  ${(props) =>
    props.isError &&
    css`
      background: #441111;
      color: #ffcccc;
      border: 1px solid #ff4444;
    `}
`;

export const InputArea = styled.form`
  padding: 15px;
  background: #050505;
  display: flex;
  gap: 8px;
  border-top: 1px solid #222;

  input {
    flex: 1;
    background: #111;
    border: 1px solid #333;
    padding: 12px;
    border-radius: 8px;
    color: #fff;
    outline: none;
    font-size: 14px;
    &:focus {
      border-color: #d4af37;
    }
  }

  button {
    background: #d4af37;
    border: none;
    padding: 0 18px;
    border-radius: 8px;
    font-weight: bold;
    cursor: pointer;
    transition: 0.2s;
    &:hover:not(:disabled) {
      filter: brightness(1.2);
    }
    &:disabled {
      opacity: 0.5;
    }
  }
`;

export const ToggleChatBtn = styled.button`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: #000;
  border: 2px solid #d4af37;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 0 20px rgba(212, 175, 55, 0.4);
  transition: 0.3s;

  /* 🔑 Reativa o clique no botão */
  pointer-events: all;

  &:hover {
    transform: scale(1.1);
    background: #111;
  }

  svg {
    width: 30px;
    height: 30px;
  }

  span {
    color: #d4af37;
    font-size: 30px;
    font-weight: bold;
  }
`;
